import dayjs from 'dayjs'
import React from 'react'
import { useForm } from 'react-hook-form'
import { Dialog, GridHookForm } from 'vnetwork-ui'
import type { StageDialogProps } from './career-path-types'

const StageDialog: React.FC<StageDialogProps> = ({
    open,
    onClose,
    editingStage,
    stages,
    isLoading,
    onSubmit,
    t,
}) => {
    const formControl = useForm({
        defaultValues: editingStage
            ? {
                  career_path_stage: editingStage.career_path_stage,
                  career_path_start_date: dayjs(
                      editingStage.career_path_start_date
                  ),
                  career_path_end_date: editingStage.career_path_end_date
                      ? dayjs(editingStage.career_path_end_date)
                      : null,
                  career_path_note: editingStage.career_path_note || '',
              }
            : {
                  career_path_stage: '',
                  career_path_start_date: null,
                  career_path_end_date: null,
                  career_path_note: '',
              },
    })

    React.useEffect(() => {
        if (open) {
            formControl.reset(
                editingStage
                    ? {
                          career_path_stage: editingStage.career_path_stage,
                          career_path_start_date: dayjs(
                              editingStage.career_path_start_date
                          ),
                          career_path_end_date:
                              editingStage.career_path_end_date
                                  ? dayjs(editingStage.career_path_end_date)
                                  : null,
                          career_path_note: editingStage.career_path_note || '',
                      }
                    : {
                          career_path_stage: '',
                          career_path_start_date: null,
                          career_path_end_date: null,
                          career_path_note: '',
                      }
            )
        }
    }, [open, editingStage, formControl])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={
                editingStage
                    ? t('career_path.edit_stage')
                    : t('career_path.add_stage')
            }
            closeOnClick
        >
            <GridHookForm
                formControl={formControl}
                onSubmit={onSubmit}
                className="grid grid-cols-2 gap-4"
                data={[
                    {
                        formItemProps: {
                            name: 'career_path_stage',
                            label: t('career_path.stage'),
                            type: 'select',
                            placeholder: t('career_path.stage'),
                            options: stages,
                            allowClear: false,
                        },
                        className: 'col-span-2',
                    },
                    {
                        formItemProps: {
                            name: 'career_path_start_date',
                            label: t('career_path.start_date'),
                            type: 'datepicker',
                            placeholder: t('career_path.start_date'),
                        },
                        className: 'col-span-1',
                    },
                    {
                        formItemProps: {
                            name: 'career_path_end_date',
                            label: t('career_path.end_date'),
                            type: 'datepicker',
                            placeholder: t('career_path.end_date'),
                        },
                        className: 'col-span-1',
                    },
                    {
                        formItemProps: {
                            name: 'career_path_note',
                            label: t('career_path.note'),
                            type: 'textarea',
                            placeholder: t('career_path.note'),
                        },
                        className: 'col-span-2',
                    },
                ]}
                actions={[
                    {
                        title: t('cancel'),
                        type: 'button',
                        variant: 'outline',
                        handler: onClose,
                    },
                    {
                        title: t('save'),
                        type: 'submit',
                        variant: 'default',
                        loading: isLoading,
                        disabled: isLoading,
                    },
                ]}
            />
        </Dialog>
    )
}

export default StageDialog
